/** @type {import('./$types').PageLoad} */
export async function load({ params }) {
	const apiURL = import.meta.env.VITE_APIURL;
	const documentId = params.newsId;
	const apiEndpoint = apiURL + 'news/news/' + documentId;

	const documentObject = await (await fetch(apiEndpoint)).json();

	return {
		documentObject: documentObject
	};
}
